export var PremiumUtils;
(function (PremiumUtils) {
    // TODO: Should we move this to formatMoneyAmount?
    function getInvalidValueString() {
        return '--,--';
    }
    PremiumUtils.getInvalidValueString = getInvalidValueString;
    function formatValue(value, locale) {
        return typeof value === 'number'
            ? locale.formatMoneyAmount(value)
            : getInvalidValueString();
    }
    PremiumUtils.formatValue = formatValue;
    function getRegularPremium(premium, locale) {
        return formatValue(premium?.regularPremium, locale);
    }
    PremiumUtils.getRegularPremium = getRegularPremium;
    function getInsuredValue(premium, locale) {
        return formatValue(premium?.insuredValue, locale);
    }
    PremiumUtils.getInsuredValue = getInsuredValue;
    function getTechnicalValue(premium, key) {
        return premium?.technicalValues?.find((v) => v?.key === key)?.value;
    }
    PremiumUtils.getTechnicalValue = getTechnicalValue;
    function getNumericTechnicalValue(premium, key) {
        const value = getTechnicalValue(premium, key);
        switch (typeof value) {
            case 'string': {
                const number = Number(value); // stricter conversation than parseFloat
                return isNaN(number) ? undefined : number;
            }
            case 'number':
                return value;
        }
        return undefined;
    }
    PremiumUtils.getNumericTechnicalValue = getNumericTechnicalValue;
})(PremiumUtils || (PremiumUtils = {}));
